import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { NameCell as BaseNameCell } from 'components/organisms/timesheets/common/cells/name-cell';

const StyledNameCell = styled(BaseNameCell)`
  display: flex;
`;

interface Props {
  logo: ReactNode;
  primaryText: ReactNode;
}
export const NameCell: FC<Props> = ({ logo, primaryText }) => (
  <StyledNameCell logo={logo} primaryText={primaryText} />
);
